import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { modalPrimaryButtonStyle } from '../styles/buttonStyles'

const VehicleLimitModal = ({
  open,
  onClose,
  maxVehiclesLimit
}) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key !== 'Escape') return

      e.preventDefault()
      e.stopPropagation()
      onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#122629',
          padding: 20,
          border: '2px solid #107c6b',
          borderRadius: 12,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: 'clamp(320px, 32vw, 460px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            marginBottom: 24
          }}
        >
          <p
            style={{
              fontSize: 20,
              margin: '0 0 14px 0',
              color: '#d9ffe4',
              fontWeight: 700
            }}
          >
            {t('TRIPLOG.VEHICLES.LIMIT_TITLE')}
          </p>

          <p
            style={{
              fontSize: 15,
              lineHeight: 1.5,
              margin: 0,
              color: 'rgba(217,255,228,0.85)'
            }}
          >
		{t('TRIPLOG.VEHICLES.LIMIT_MSG', {
 		 limit: maxVehiclesLimit
		})}
          </p>
        </div>

        <button
          style={modalPrimaryButtonStyle(
            pressedBtn,
            'close',
            hoverBtn === 'close'
          )}
          onMouseEnter={() => setHoverBtn('close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('close')}
          onMouseUp={() => setPressedBtn(null)}
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default VehicleLimitModal